import React, { Component } from 'react';

import { Drag } from 'components/drag';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import SubtitleActions from '../SubtitleActions';

@inject((stores) => ({
  scrollPosition: stores.SubtitleStore.scrollPosition,
  zoom: stores.SubtitleStore.zoom
}))
@observer
export default class SubtitleTimelineAreaScroll extends Component {
  scrollRef = React.createRef();

  static propTypes = {
    timelineWidth: PropTypes.number,
    scrollPosition: PropTypes.number,
    zoom: PropTypes.number
  };

  get scrollWidth() {
    return (
      this.scrollRef.current &&
      this.scrollRef.current.getBoundingClientRect().width
    );
  }

  get scrollbarPercentage() {
    const { timelineWidth } = this.props;

    return this.scrollWidth / timelineWidth;
  }

  get scrollbarWidth() {
    return this.scrollWidth * this.scrollbarPercentage;
  }

  get isScrollbarEnabled() {
    return this.scrollbarWidth < this.scrollWidth;
  }

  get maxPosition() {
    return 1 - this.scrollbarPercentage;
  }

  get marginLeft() {
    const { scrollPosition } = this.props;

    const position = this.isOverflowing(scrollPosition)
      ? this.maxPosition
      : scrollPosition;

    return this.scrollWidth * position;
  }

  isOverflowing(scrollPosition) {
    return scrollPosition > this.maxPosition;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.zoom !== this.props.zoom) {
      this.changePosition(0);
    }

    if (this.isOverflowing(this.props.scrollPosition)) {
      SubtitleActions.setScrollPosition(this.maxPosition);
    }
  }

  render() {
    const style = { width: this.scrollbarWidth, marginLeft: this.marginLeft };

    return (
      <div className="subtitle__timeline__area__scroll__outer">
        <div ref={this.scrollRef} className="subtitle__timeline__area__scroll">
          {this.isScrollbarEnabled && (
            <Drag onCueMove={this.changePosition}>
              <span
                onMouseDown={this.onMouseDown}
                className="subtitle__timeline__area__scrollbar"
                style={style}
              ></span>
            </Drag>
          )}
        </div>
      </div>
    );
  }

  changePosition = (pixelsMoved) => {
    SubtitleActions.movePixels(pixelsMoved, this.scrollWidth);
  };
}
